<div class="relative flex flex-col justify-center overflow-hidden py-16 sm:py-20 lg:py-24 h-[60vh] bg-cover bg-center bg-no-repeat" style="background-image: url('pexels-expect-best-79873-323780.jpg');">
  <div class="absolute inset-0 bg-bg-base/60 backdrop-blur-sm z-0"></div>
  <!-- Premium background glow effects -->
  <div class="pointer-events-none absolute inset-0 opacity-40">
    <div class="absolute left-1/4 top-0 h-[400px] w-[400px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-soft blur-[100px]"></div>
    <div class="absolute right-0 bottom-0 h-[500px] w-[500px] translate-x-1/3 translate-y-1/3 rounded-full bg-primary-deep blur-[120px]"></div>
  </div>

  <div class="relative z-10 mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-10 sm:mb-12 lg:mb-16">
      <!-- Badge -->
      <div
        class="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4 sm:mb-6 border border-primary/20 bg-primary-soft/30 backdrop-blur-md shadow-subtle"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-4 h-4 sm:w-5 sm:h-5 text-primary"
          aria-hidden="true"
        >
          <path d="M12 10h.01"></path>
          <path d="M12 14h.01"></path>
          <path d="M12 6h.01"></path>
          <path d="M16 10h.01"></path>
          <path d="M16 14h.01"></path>
          <path d="M16 6h.01"></path>
          <path d="M8 10h.01"></path>
          <path d="M8 14h.01"></path>
          <path d="M8 6h.01"></path>
          <path d="M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"></path>
          <rect x="4" y="2" width="16" height="20" rx="2"></rect>
        </svg>
        <span class="text-sm sm:text-base font-medium text-text-primary">{{ 'projects.header.badge' | translate }}</span>
      </div>

      <!-- Title -->
      <h1 class="h1 mb-4 sm:mb-6">
        <span class="text-transparent bg-clip-text bg-gradient-to-r from-text-primary to-text-secondary">
          {{ 'projects.header.title' | translate }}
        </span>
      </h1>

      <!-- Description -->
      <p class="body-large max-w-2xl mx-auto px-4">
        {{ 'projects.header.subtitle' | translate }}
      </p>
    </div>

    <!-- Search Bar -->
    <form class="max-w-3xl mx-auto group" (ngSubmit)="onSearch($event)">
      <div
        class="surface-elevated p-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-2 transition-all duration-300 hover:border-border-primary hover:shadow-primary-glow focus-within:border-primary focus-within:shadow-primary-glow"
      >
        <!-- Search Input -->
        <div class="flex-1 flex items-center gap-3 px-4 py-2 sm:py-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-5 h-5 text-text-muted flex-shrink-0 group-focus-within:text-primary transition-colors"
            aria-hidden="true"
          >
            <path d="m21 21-4.34-4.34"></path>
            <circle cx="11" cy="11" r="8"></circle>
          </svg>
          <input
            type="text"
            [placeholder]="'projects.header.searchPlaceholder' | translate"
            class="flex-1 py-3 bg-transparent text-text-primary placeholder-text-muted focus:outline-none text-sm sm:text-base"
            name="projectSearch"
            [(ngModel)]="searchTerm"
          />
        </div>

        <!-- Action Buttons -->
        <div class="flex items-center gap-2">
          @if (searchTerm.trim()) {
            <button
              type="button"
              (click)="onClear()"
              class="btn-secondary flex-1 sm:flex-none h-12 px-5 sm:px-6"
            >
              {{ 'projects.header.clearButton' | translate }}
            </button>
          }
          <button
            type="submit"
            class="btn-gradient flex-1 sm:flex-none h-12 px-6 sm:px-8"
          >
            {{ 'projects.header.searchButton' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
